var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mr-3 signatures-container" }, [
    _c(
      "div",
      { staticClass: "signatures-sticky-container" },
      [
        _c(
          "b-form-group",
          { staticClass: "mb-3" },
          [
            _c("b-form-input", {
              attrs: {
                id: "tourStep2",
                placeholder: _vm.placeholder,
                name: "search",
                size: "sm"
              },
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        ),
        _vm._l(_vm.signaturesFiltered, function(signature) {
          return _c("Signature", {
            key: signature.id,
            staticClass: "mb-2",
            attrs: {
              name: signature.name,
              closable: _vm.closableSign || signature.id === _vm.value.id,
              selected: signature.id === _vm.value.id,
              positioned: signature.positioned
            },
            on: {
              click: function($event) {
                return _vm.$emit("input", signature)
              },
              close: function($event) {
                return _vm.$emit("input", undefined)
              }
            }
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }